import PracticeResult from "../../component/PracticeResult";
import Modal from "../../component/TailwindModal";
import ToastNotification from "../../component/ToastNotification";
import RenderOptions from "./RenderOptions";
import useMCQTest from "./useMCQTest";
import parse from "html-react-parser";

const MCQTestPage = () => {
  const {
    state,
    testQuestions,
    examMode,
    totalQuestion,
    questionsInfoSummary,
    current,
    index,
    handleChange,
    nextHandler,
    markForReviewHandler,
    previousHandler,
    handleOptionSelect,
    saveAndNextHandler,
    clearHandler,
    saveAndMarkHandler,
    handleSubmit,
    closeModal,
    doneHandler,
    onClose,
  } = useMCQTest();
  return (
    <div className="p-10 mt-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <div className="flex w-full">
        <div className="w-full border rounded-sm p-5 flex flex-col">
          <span className="font-bold  mb-5">Question {index}</span>
          <hr className="mb-5" />
          <span
            className="font-bold mb-5 flex items-center medium-text dark-text"
            style={{ fontSize: "20px" }}
          >
            {parse(testQuestions[current]?.TestQuestionsPtr?.QuesTitle || "")}
          </span>

          <RenderOptions
            data={testQuestions[current]?.TestQuestionsPtr}
            state={state.selectedAns}
            correctAns={state.correctAns}
            handleOptionSelect={handleOptionSelect}
            examMode={examMode}
          />
          <hr className="mb-5 mt-5" />
          <div className="flex flex-wrap gap-5 items-center">
            <button
              className="py-2 px-4 flex items-center border bg-green-600 uppercase rounded text-white font-bold text-xl hover:bg-green-700"
              onClick={() => {
                saveAndNextHandler(
                  current,
                  testQuestions[current]?.TestQuestionsPtr?.objectId
                );
              }}
            >
              Save & Next
            </button>
            <button
              className="py-2 px-4 flex items-center border bg-orange-500 uppercase rounded text-white font-bold text-xl hover:bg-orange-700"
              onClick={() => {
                saveAndMarkHandler(
                  current,
                  testQuestions[current]?.TestQuestionsPtr?.objectId
                );
              }}
            >
              Save & Mark for Review
            </button>
            <button
              className="py-2 px-4 flex items-center rounded uppercase font-bold text-xl border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-400"
              onClick={() =>
                clearHandler(
                  testQuestions[current]?.TestQuestionsPtr?.objectId,
                  current
                )
              }
            >
              Clear Response
            </button>

            <button
              className="py-2 px-4 flex items-center border bg-cyan-700 uppercase rounded text-white font-bold text-xl hover:bg-cyan-800"
              onClick={() => {
                markForReviewHandler(
                  current,
                  testQuestions[current]?.TestQuestionsPtr?.objectId
                );
              }}
            >
              Mark for Review & Next
            </button>
          </div>

          <hr className="mb-5 mt-5" />
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center">
              <button
                className="py-2 px-4 flex items-center border border-gray-300 uppercase rounded text-gray-800 font-bold text-xl hover:bg-gray-100"
                onClick={() => previousHandler(current)}
                disabled={!current}
              >
                <span style={{ fontSize: "30px", margin: "-4px 10px 0px" }}>
                  &#171;
                </span>{" "}
                Back
              </button>
              <button
                disabled={current === testQuestions?.length - 1}
                className="py-2 px-4 flex items-center border border-gray-300 uppercase rounded text-gray-800 font-bold text-xl hover:bg-gray-100"
                onClick={() => {
                  nextHandler(
                    current,
                    testQuestions[current]?.TestQuestionsPtr?.objectId
                  );
                }}
              >
                Next
                <span style={{ fontSize: "30px", margin: "-4px 10px 0px" }}>
                  &#187;
                </span>
              </button>
            </div>
            <button
              onClick={handleSubmit}
              className="py-2 px-4 flex items-center border bg-green-600 uppercase rounded text-white font-bold text-xl hover:bg-green-700"
            >
              Submit
            </button>
          </div>
        </div>
        <div className="w-2/4 border p-2 pt-5">
          <div className="flex gap-5 flex-wrap mb-5 p-5 border rounded border-green-400">
            <div className="flex items-center gap-3">
              <span className="bg-gray-300 h-12 w-12 flex items-center justify-center rounded text-xl border border-gray-400 text-black font-semibold">
                {questionsInfoSummary?.filter((s) => !s.status)?.length}
              </span>
              <span className="text-cyan-600 font-semibold text-xl">
                Not visited
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span
                className="bg-orange-600 h-12 w-12 flex items-center justify-center rounded text-xl text-white font-semibold"
                style={{ borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }}
              >
                {
                  questionsInfoSummary?.filter(
                    (s) => s.status === "notAnswered"
                  )?.length
                }
              </span>
              <span className="text-yellow-900 font-semibold text-xl">
                Not Answered
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span
                className="bg-green-700 h-12 w-12 flex items-center justify-center text-xl text-white font-semibold "
                style={{ borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }}
              >
                {
                  questionsInfoSummary?.filter((s) => s.status === "answered")
                    ?.length
                }
              </span>
              <span className="text-green-700 font-semibold text-xl">
                Answered
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="h-12 w-12 flex items-center justify-center text-white text-xl font-semibold bg-cyan-700 rounded-full">
                {
                  questionsInfoSummary?.filter(
                    (s) => s.status === "markedForReview"
                  )?.length
                }
              </span>
              <span className="text-purple-900 font-semibold text-xl">
                Marked for Review
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span className="bg-purple-900 rounded-full text-xl h-12 w-12 flex items-center justify-center text-white font-semibold">
                {
                  questionsInfoSummary?.filter(
                    (s) => s.status === "saveAndMark"
                  )?.length
                }
              </span>
              <span className="text-red-900 font-semibold text-xl">
                Answered & Marked for Review
              </span>
            </div>
          </div>
          <div className="grid grid-cols-10 items-center gap-1">
            {questionsInfoSummary?.map((x, i) => (
              <span
                key={x?.id}
                onClick={() => handleChange(i, x?.id)}
                className={`p-2 border flex items-center justify-center cursor-pointer hover:font-semibold ${
                  x.status === "notAnswered"
                    ? "bg-orange-600 text-white rounded-lg font-semibold "
                    : x.status === "markedForReview"
                    ? "bg-cyan-700 rounded-full text-white font-semibold"
                    : x.status === "answered"
                    ? "bg-green-700 text-white font-semibold rounded-lg"
                    : x.status === "saveAndMark"
                    ? "bg-purple-900 text-white font-semibold rounded-full"
                    : i === current && !x.status
                    ? "bg-gray-300 border border-gray-400 rounded font-semibold"
                    : "bg-gray-300 border border-gray-400 rounded font-semibold"
                }`}
                style={
                  x.status === "answered" || x.status === "notAnswered"
                    ? { borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }
                    : {}
                }
              >
                {++i}
              </span>
            ))}
          </div>
        </div>
      </div>
      {state.isNotAnswered && (
        <ToastNotification
          showToast={state.isNotAnswered}
          message="Please select an answer and try again."
          warningActive={true}
        />
      )}
      {state.isSave && (
        <Modal
          isOpen={state.isSave}
          onSubmit={closeModal}
          data={questionsInfoSummary}
          onClose={onClose}
        />
      )}
      {state.isSubmit && (
        <PracticeResult isOpen={state.isSubmit} onclose={doneHandler} />
      )}
    </div>
  );
};

export default MCQTestPage;
